<template>
    <div class="waiting">
        <div class="container">
            <div class="text-center">
                <img src="../assets/image/waiting_illustration.png" class="waiting_img" alt="">
            </div>
            <div class="text-center">
                <div class="spinner-border text-danger" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>
            <div class="text-center">
                <h1 class="title">
                    Menunggu Validasi
                </h1>
                <p class="text">
                    Data anda sedang divalidasi oleh Admin, mohon menunggu beberapa saat...
                </p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Waiting',
    mounted(){
        setTimeout(() => {
            this.$router.push('/profiling');
        }, 3000);
    }
}
</script>

<style scoped>
.waiting{
    padding: 50px;
}
.waiting .waiting_img{
    margin-bottom: 30px;
    width: 50%;
}
.waiting .title{
    color: var(--red);
    font-weight: 700;
}

@media(max-width: 767.98px){
    .waiting .waiting_img{
        margin-bottom: 30px;
        width: 70%;
    }
}
</style>